export const localizeDateToString = (value: string) =>
  new Date(value)?.toLocaleString('sv-SV')

export const localizeDateToDateString = (value: string) =>
  new Date(value)?.toLocaleDateString('sv-SV')
